import { RouteObject } from "react-router-dom";

const invoiceRoutes: RouteObject[] = [
	{ path: "racuni", lazy: () => import("@/pages/Invoices/InvoicesPage") },
	{ path: "racuni/:invoiceId", lazy: () => import("@/pages/Invoices/InvoicesDetails") },
	{
		path: "postavke-aplikacije/fina-e-racun",
		lazy: () => import("@/pages/ApplicationConfig/FinaInvoiceCertificates/FinaInvoiceCertificatesPage")
	}
];

export default invoiceRoutes;